import Div from "@jumbo/shared/Div"
import * as yup from "yup"
import { Autocomplete, Box, Button, TextField, Typography } from '@mui/material';
import React, { createContext, useEffect, useRef, useState } from 'react'
import { Form, Formik, } from "formik"
import AddCompany from "../AddCompany";
import { Axios } from "index";
import AllApis from "app/Apis/apis";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Heading from 'app/pages/Component/Heading';
import Address from "app/pages/components/Address/Index";
import AddBranch from "app/pages/components/AddBranch/AddBranch";
import AddKyc from "app/pages/components/AddBranch/AddKyc";
import AddContact from "app/pages/components/AddBranch/AddContact";

export const BranchFormContext = createContext(null)

const AddEditOfflinestore = function () {

    //while editing companyBranch 
    const { id } = useParams(); //branch id
    const { state } = useLocation();
    const branchData = state?.branchData //company branch data

    //creating refernce for all form to submit in one button
    const branchRef = useRef(null);
    const kycFormikRef = useRef(null);
    const addressFormikRef = useRef(null);
    const contactFormikRef = useRef(null);

    const [isSubmitting, setIsSubmitting] = useState(false)
    const navigate = useNavigate();
    //setting the array of masters which i used as dropdown in addbranch components
    const [companyDropdown, setCompanyDropdown] = useState([]);

    //selected one companyId from dropdown 
    //while editing if id and branchData is there it will set directly
    const [companyId, setCompanyId] = useState(!(id && branchData) ? {
        _id: "",
        company_name: ""
    } : {
        _id: branchData?.offlinestoreId?._id,
        company_name: branchData?.offlinestoreId?.current_data?.company_name
    });

    //while editing if id and branchData setting data initail value is branch data
    const [data, setData] = useState(!(id && branchData) ? {
        // offlinestoreId: companyId?._id,
        branch_name: "",
        branch_onboarding_date: new Date(Date.now()).toISOString().split('T')[0],
        kyc: {
            // pan: {
            //     pan_no: "",
            //     pan_image: "",
            // },
            gst: {
                gst_no: "",
                gst_image: "",
            },
            bank_details: {
                bank_name: "",
                account_no: "",
                confirm_account_no: "",
                ifsc_code: "",
                passbook_image: "",
            },
        },
        branch_address: {
            address: "",
            location: "",
            area: "",
            district: "",
            taluka: "",
            state: "",
            city: "",
            country: "",
            pincode: "",
        },
        contact_person: [],
    } : { ...branchData, offlinestoreId: branchData?.offlinestoreId?._id, branch_onboarding_date: new Date(branchData?.branch_onboarding_date).toISOString().split('T')[0] })



    const handleSubmitssss = async () => {
        const formRefs = [branchRef, kycFormikRef, addressFormikRef, contactFormikRef];
        try {
            setIsSubmitting(true)
            await Promise.all(formRefs.map((ref) => ref.current.submitForm()))
            const errors = await Promise.all(formRefs.map((ref) => ref.current.validateForm()));
            if (contactFormikRef?.current?.values?.contact_person.length <= 0) {
                Swal.fire({
                    icon: "warning",
                    title: "At least one contact person is required",
                    text: "",
                    timer: 1200,
                    showConfirmButton: false,
                })
                setIsSubmitting(false)
                return;
            }
            if (errors.every((formErrors) => Object.values(formErrors).every((fieldErrors) => !fieldErrors))) {
                const payload = {
                    // offlinestoreId: branchRef?.current?.values?.offlinestoreId,
                    branch_name: branchRef?.current?.values?.branch_name,
                    branch_onboarding_date: branchRef?.current?.values?.branch_onboarding_date,
                    kyc: kycFormikRef?.current?.values,
                    branch_address: addressFormikRef?.current?.values,
                    contact_person: contactFormikRef?.current?.values?.contact_person,
                }
                const formData = new FormData();
                formData.append("branchData",JSON.stringify(payload));
                formData.append("pan_image", payload?.kyc?.pan?.pan_image)
                formData.append("gst_image", payload?.kyc?.gst?.gst_image)
                formData.append("passbook_image", payload?.kyc?.bank_details?.passbook_image);

                let AddBranch;

                if (!(id && branchData)) {
                    //Add Branch
                    AddBranch = await Axios.post(AllApis?.offlinestore.branch.add, formData);
                    if (AddBranch?.data?.statusCode === 201) {
                        Swal.fire({
                            icon: "success",
                            title: AddBranch?.data?.status,
                            text: AddBranch?.data?.message,
                            timer: 1000,
                            showConfirmButton: false,
                        })
                        setIsSubmitting(false)
                    }
                    navigate(`/dashboards/myBranch`)
                } else {
                    //Edit branch
                    AddBranch = await Axios.patch(AllApis?.offlinestore.branch.edit(id), payload);
                    if (AddBranch?.data?.statusCode === 200) {
                        Swal.fire({
                            icon: "success",
                            title: AddBranch?.data?.status,
                            text: AddBranch?.data?.message,
                            timer: 1000,
                            showConfirmButton: false,
                        })
                        setIsSubmitting(false)
                    }
                    navigate(`/dashboards/myBranch`)
                }
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "Invalid Form Details",
                    text: "please fill out the form correctly",
                    // timer: 1200,
                    showConfirmButton: true,
                })
            }
            setIsSubmitting(false)
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: error?.response?.data?.message,
                text: "",
                timer: 1000,
                showConfirmButton: false,
            })
            setIsSubmitting(false)
        }
    };

    // const getCompanyDropdown = async (companyType)=>{
    //     try {
    //         const {data} = await Axios.get(AllApis?.offlinestore.dropdown);
    //         return data?.data?.offlinestore
    //     } catch (error) {
    //         return new Error(error)
    //     }
    // }

    // useEffect(() => {
    //     try {
    //         getCompanyDropdown(companyType).then((list) => {
    //             if (list) {
    //                 setCompanyDropdown([...list])
    //             }
    //         })

    //     } catch (error) {
    //         console.log(error)
    //     }
    // }, [companyId, companyType])

    useEffect(() => {
        setData((pre) => ({ ...pre, companyId: companyId?._id }))
    }, [companyId])

    return (
        <>
            <Div sx={{ mt: -4 }}>
                {state?.addBranch !== true && <Heading Name={!(id && branchData) ? `Add Branch` : `Edit Branch`}></Heading>}

                {/* {!(id && branchData) && state?.addBranch !== true && <AddCompany
                    setCompanyId={setCompanyId}
                    companyId={companyId}
                />} */}

                {/* branch */}
                {(companyId?._id || branchData || state?.addBranch === true) && <BranchFormContext.Provider value={{
                    branchProps: {
                        companyId: companyId,
                        setCompanyId: setCompanyId,
                        addBranch: state?.addBranch,
                        data: data,
                        setData: setData,
                        companyDropdown: companyDropdown,
                    }
                }}>
                    <Div sx={{ marginTop: "2%" }}>
                        <Typography variant="h2">{!(id && branchData) ? "Add" : "Edit"} Branch</Typography>

                        <AddBranch formikRef={branchRef} />

                        <AddKyc formikRef={kycFormikRef} />

                        <Address formikRef={addressFormikRef} />

                        <AddContact formikRef={contactFormikRef} />

                        <Div
                            sx={{
                                width: "92%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 3,
                                mt: 4,
                            }}
                        >
                            <Button
                                sx={{ width: "100px" }}
                                variant="outlined"
                                onClick={() => navigate(`/dashboards/myBranch`)}
                            >
                                Back
                            </Button>

                            <LoadingButton
                                variant="contained"
                                type="submit"
                                onClick={handleSubmitssss}
                                sx={{ width: "100px" }}
                                loading={isSubmitting}
                            >
                                submit
                            </LoadingButton>
                        </Div>
                    </Div>
                </BranchFormContext.Provider>}
            </Div>
        </>
    )
}
export default AddEditOfflinestore